import { Tab } from "@pentabd/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import GeneralInfo from "./GeneralInfo";

export const CreateEmployeeForm = () => {
  const { t } = useTranslation();

  const [searchParams] = useSearchParams();
  const id: number | null = searchParams.get("id")
    ? Number(searchParams.get("id"))
    : null;

  const [activeTab, setActiveTab] = useState<number>(0);

  const tabData = [
    {
      label: t("EMPLOYEE.TABS.GENERAL_INFO"),
      component: <GeneralInfo id={id} />,
    },

    {
      label: t("EMPLOYEE.TABS.ATTACHED_FILES"),
      component: <></>,
    },
    {
      label: t("EMPLOYEE.TABS.FAMILY_INFO"),
      component: <></>,
    },
    {
      label: t("EMPLOYEE.TABS.QUALIFICATIONS"),
      component: <></>,
    },

    {
      label: t("EMPLOYEE.TABS.SERVICES"),
      component: <></>,
    },
    {
      label: t("EMPLOYEE.TABS.POSTINGS"),
      component: <></>,
    },
  ];

  return (
    <Tab active={activeTab} setActiveTab={setActiveTab}>
      <Tab.Heads>
        {tabData.map(({ label }, i) => (
          <Tab.Item
            key={i}
            index={i}
            label={label}
            disabled={i > 0 && !id ? true : false}
          />
        ))}
      </Tab.Heads>
      <Tab.ContentWrapper>
        {tabData.map(({ component }, i) => (
          <Tab.Content key={i} index={i}>
            {component}
          </Tab.Content>
        ))}
      </Tab.ContentWrapper>
    </Tab>
  );
};
